// test1271
(1271 && 0);
